import {defaultTheme} from "@digisthesia/remix-utils/mantine.config";
import {MantineThemeOverride} from "@mantine/core";

export const HexploitTheme: MantineThemeOverride = {
  ...defaultTheme,
  primaryColor: "violet",
  defaultRadius: "lg",
  fontSizes: {
    xl: "3rem",
    lg: "1.5rem",
    md: "1.2rem",
    sm: "1rem",
    xs: "0.8rem",
  },
};
